import { TextAnchor, TextAnchorProps } from "@dgs/core";
import React, { FC } from "react";
import styled from "styled-components";

const BreakWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;
	white-space: nowrap;
`;

interface Props {
	items: string[];
	render: (item: string) => React.ReactNode;
}

const StyledAnchor = styled(TextAnchor)`
	font-size: inherit;
	text-transform: lowercase;
	white-space: nowrap;
	color: inherit;
	text-decoration: underline;
`;

export const ContactMeans: FC<Props> = ({ items, render }) => {
	return (
		<BreakWrapper>
			{items.map((item, index) => {
				return <React.Fragment key={index}>{render(item)}</React.Fragment>;
			})}
		</BreakWrapper>
	);
};

interface ContactAnchorProps extends Omit<TextAnchorProps, "onClick"> {
	type: "mailto" | "tel";
}

export const ContactAnchor: FC<ContactAnchorProps> = ({ type, children }) => {
	return (
		<StyledAnchor onClick={(e) => e.stopPropagation()} href={`${type}:${children}`}>
			{children}
		</StyledAnchor>
	);
};
